import IActivityService from "../../spi/IActivityService";
import IActivity, { IActivityFilter, IActivityActor, IActivityContent, IActivityMeeting, IActivityType, IActivityCollection, convertToActivity } from "../../../types/IActivity";
import FirebaseService from "./FirebaseService";
import ElasticSearchService from "../elastic/ElasticSearchService";
import IUser from "../../../types/IUser";
import moment from "moment";
import Paginator, { IPaginatorQueryType, IFirebasePaginatorOperation } from "../../../types/Paginator";
import IPaginator from "../../../types/Paginator";

export default class FirebaseActivityService implements IActivityService{
    
    async getActivities(pg: IPaginator, filter?: IActivityFilter): Promise<IActivityCollection> {
        let paginator = pg == null ? {
          type: filter == null ? IPaginatorQueryType.Firebase : IPaginatorQueryType.Elastic,
          totalPages: 0,
          pageNumber: 0,
          rowsPerPage: 6
        } : pg;
        let collection: IActivityCollection = {
          activities: [],
          paginator: pg
        };
    
        try {
    
          if (paginator.type == IPaginatorQueryType.Elastic) {
            //search
            const searchResults = await new ElasticSearchService().searchActivities(paginator.rowsPerPage, paginator.pageNumber, filter);
    
            if (searchResults && searchResults.data) {
              const hitsArray: any = searchResults.data.hits.hits;
              const totalHits: number = searchResults.data.hits.total;
              hitsArray.forEach((hit: any) => {
                const rawDoc: any = hit._source;
                const _id: string = hit._id;
                const activity: IActivity = convertToActivity(rawDoc);
                activity.uid = _id;
                collection.activities.push(activity);
              });
              collection.paginator = {
                type: IPaginatorQueryType.Elastic,
                totalPages: Math.ceil(totalHits / paginator.rowsPerPage),
                pageNumber: paginator.pageNumber,
                rowsPerPage: paginator.rowsPerPage,
              };
            }
          } else {
            let snapshot: any = null;
            if (paginator.fbOperation == IFirebasePaginatorOperation.Next) {
              snapshot = await FirebaseService.getInstance()
                .activities()
                //.orderBy("name", "asc")
                .startAt(paginator.nextCursor)
                .limit(paginator.rowsPerPage)
                .get();
            } else if (paginator.fbOperation == IFirebasePaginatorOperation.Prev) {
              snapshot = await FirebaseService.getInstance()
                .activities()
                //.orderBy("name", "desc")
                .startAt(paginator.prevCursor)
                .limit(paginator.rowsPerPage)
                .get();
            } else {
              snapshot = await FirebaseService.getInstance()
                .activities()
                //.orderBy("name", "desc")
                .limit(paginator.rowsPerPage)
                .get();
            }
    
            if (!snapshot.empty) {
              snapshot.forEach((child: any, i: number) => {
                const key = child.id;
                const cust = child.data();
                cust.uid = key;
                //const document:IDocument = this._getIDocument(key, owner, coverTemplate, doc);
                const activity: IActivity = convertToActivity(cust);
                collection.activities.push(activity);
                if (i == 0) {
                  paginator.prevCursor = child
                }
                paginator.nextCursor = child;
              });
              collection.paginator = {
                totalPages: 0,
                pageNumber: 0,
                rowsPerPage: paginator.rowsPerPage,
                type: IPaginatorQueryType.Firebase,
                prevCursor: paginator.prevCursor,
                nextCursor: paginator.nextCursor
              }
    
            }
          }
        } catch (e) {
          debugger;
          console.log(e)
          throw e;
        }
        return collection;
      }
    
    
    /*private _getIActivity(key:string, act:any):IActivity{
        const primaryActor:IActivityActor = {
            uid: act.primaryActor.uid,
            name: act.primaryActor.name,
            role: act.primaryActor.role
        };
        const secondaryActors:Array<IActivityActor>  = act.secondaryActors ? act.secondaryActors.map((sec:any)=>{
            return {
                uid: sec.uid,
                name: sec.name,
                role: sec.role
            }
        }): [];
        const content:IActivityContent|undefined = act.content ? {
            uid: act.content.uid,
            title: act.content.title,
            duration: act.content.duration
        } : undefined;
        const meeting:IActivityMeeting|undefined = act.meeting ? {
            uid: act.meeting.uid,
            title: act.meeting.title,
            invitedOn: act.meeting.invitedOn,
            duration: act.meeting.duration
        }: undefined;
        const activity:IActivity =  {
            uid: key,
            activityType: this._decodeActivityType(act.activityType),
            primaryActor: primaryActor,
            secondaryActors: secondaryActors,
            content: content,
            meeting: meeting,
            channel: act.channel,
            time: act.time
        }
        return activity;
    }

    private _decodeActivityType = (type:any):IActivityType => {
        let retType:IActivityType = IActivityType.None;
        if(!type){
            retType = IActivityType.None;
        }else if(type === 'ContentShared'){
            retType = IActivityType.ContentShared;
        }else if (type === 'ContentVisited'){
            retType = IActivityType.ContentVisited;
        }else if(type === 'MeetingAttended'){
            retType = IActivityType.MeetingAttended
        }else if(type === 'MeetingAttended'){
            retType = IActivityType.MeetingAttended
        }

        return retType;
    }*/

    async invitationSent(sender: IActivityActor, meeting: IActivityMeeting, recipient: IActivityActor): Promise<IActivity> {
        return await this.createActivity({
            uid: '',
            activityType: IActivityType.MeetingInvited,
            primaryActor: sender,
            secondaryActors: [recipient],
            meeting: meeting,
            channel: 'WEB',
            time: moment().unix()
        });
    }

    async meetingAttended(attendee: IActivityActor, meeting: IActivityMeeting, duration: number): Promise<IActivity> {
        return await this.createActivity({
            uid: '',
            activityType: IActivityType.MeetingAttended,
            primaryActor: attendee,
            secondaryActors: [],
            meeting: meeting,
            channel: 'WEB',
            time: moment().unix()
        });
    }

    async contentVisited(visitor: IActivityActor, content: IActivityContent): Promise<IActivity> {
        return await this.createActivity({
            uid: '',
            activityType: IActivityType.ContentVisited,
            primaryActor: visitor,
            secondaryActors: [],
            content: content,
            channel: 'WEB',
            time: moment().unix()
        });
    }
    
    async contentShared( sharedWith: IActivityActor, content: IActivityContent, channel: string): Promise<IActivity> {
        const loggedInUser:IUser = FirebaseService.getInstance().getCurrentUser();
        const sharedBy: IActivityActor = {
            uid: loggedInUser.uid,
            name: loggedInUser.firstName + ' ' + loggedInUser.lastName,
            role: loggedInUser.roles && loggedInUser.roles.length > 0 ? loggedInUser.roles[0].name : 'NA',
            imageUrl: loggedInUser.image == null ? '' : loggedInUser.image
        };
        return await this.createActivity({
            uid: '',
            activityType: IActivityType.ContentShared,
            primaryActor: sharedBy,
            secondaryActors: [sharedWith],
            content: content,
            channel: channel,
            time: moment().unix()
        });
    }

    private async createActivity(act: Partial<IActivity>): Promise<IActivity> {
        let activity:IActivity = {} as IActivity;
        debugger;
        try{
            FirebaseService.getInstance().activities().doc().set(act);
        }catch(e){
            throw e;
        }
        return activity;
    }

    async getActivity(actId: string): Promise<IActivity> {
        throw new Error("Method not implemented.");
    }

}